// extracted by mini-css-extract-plugin
export default {"box":"mastersVrpFilterPage_box__+-QYI","box__content":"mastersVrpFilterPage_box__content__WaUfX","box__btn":"mastersVrpFilterPage_box__btn__c70UA"};